/* eslint-disable */
export default {
  download: '下载',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
